import { type Meta } from '../types/docs';
import { AGENT_ONBOARDING_AUDIENCE_META_PARAM } from './agentOnboardingAnalytics';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'The agent onboarding splash becomes visible',
  name: 'agent_onboarding_started',
  params: [WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM, AGENT_ONBOARDING_AUDIENCE_META_PARAM],
};

export default META;
